export const ACCESS_TOKEN = 'sessionId'
